export default "__VITE_ASSET__C5oLkDP4__"